

export function utmPhone() {
  let uri = window.location.search.substring(1);
  let params = new URLSearchParams(uri);
  let phone;

  switch (params.get("utm_source")) {
    case 'google':
      phone = '74955408889';
      break;
      case 'yandex':
      phone = '74955408890';
      break;
    default:
      phone = '74955408891';
      break;
  }


  const pattern = new RegExp(`(^\\d{${phone.length % 10}})(\\d{3})(\\d{3})(\\d{2})(\\d{2}$)`);
  let formattedNumber = phone.replace(pattern, '+$1 ($2) $3-$4-$5');
  return {
    formattedNumber: formattedNumber,
    phone: phone
  };
}
